/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

// Boolean attributes by specs
// https://html.spec.whatwg.org/multipage/indices.html#attributes-3
const HTML_BOOLEAN_ATTRIBUTES = [
  'allowfullscreen',
  'allowpaymentrequest',
  'async',
  'autofocus',
  'autoplay',
  'checked',
  'controls',
  'default',
  'defer',
  'disabled',
  'formnovalidate',
  'hidden',
  'ismap',
  'itemscope',
  'loop',
  'multiple',
  'muted',
  'nomodule',
  'novalidate',
  'open',
  'playsinline',
  'readonly',
  'required',
  'reversed',
  'selected',
  'typemustmatch',
]

// LUI-specific boolean attributes
const CUSTOM_BOOLEAN_ATTRIBUTES = [
  'icononly',
  'iconposafter',
  'indeterminate',
]

export default class LuiElement extends HTMLElement {
  static get is() {
    return ''
  }

  static cssClass() {
    return this.dasherize(this.name)
  }

  static modifierCssClass(name) {
    return this.cssClass() + '-' + name
  }

  static dasherize(name) {
    return name.replace(/[A-Z]+/g, (c, p) => (p > 0 ? '-' : '') + c.toLowerCase())
  }

  static isBooleanAttribute(name) {
    return LuiElement.BOOLEAN_ATTRIBUTES.includes(name)
  }
}

LuiElement.BOOLEAN_ATTRIBUTES = [
  ...HTML_BOOLEAN_ATTRIBUTES,
  ...CUSTOM_BOOLEAN_ATTRIBUTES,
]



//////////////////
// WEBPACK FOOTER
// ./packages/lui-base/lui-element.js
// module id = 2
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38